/**
 * Push or remove an array of CSS classes to a html element
 * @param el  HTMLElement
 * @param cls Array of CSS classes to pass to that HTMLElement
 * @returns {boolean[]}
 */
export const toggleCSSClasses = (el, ...cls) =>
    cls.map((cl) => el.classList.toggle(cl));
